// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
export class EmergencyAccessPasswordRequest {
  newMasterPasswordHash: string;
  key: string;
}
